import React from "react";
import { useNavigate } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";
import { useAuth } from "../../contexts/AuthContext";
import { getDefaultDashboardRoute } from "../../utils/dashboardNavigation";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { permissions } = useAuth();
  const homeRoute = getDefaultDashboardRoute(permissions);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md">
        <FiAlertTriangle className="text-red-500 text-6xl mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-gray-800 mb-2 font-custom">
          دسترسی محدود
        </h1>
        <p className="text-gray-600 mb-6 font-custom">
          شما دسترسی لازم برای مشاهده این صفحه را ندارید.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg font-custom transition-colors"
          >
            بازگشت
          </button>
          <button
            onClick={() => navigate(homeRoute)}
            className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-lg font-custom transition-colors"
          >
            صفحه اصلی
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
